import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function UserMsg({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex justify-end", className)}>
      <div className="max-w-[85%] rounded-2xl rounded-br-md bg-fabrik-blue-soft text-foreground px-4 py-2.5 text-[13px] leading-relaxed">
        {children}
      </div>
    </div>
  );
}
